import 'twin.macro';
import styled from 'styled-components';
import Svg from './Svg';

const Icon = styled(Svg)<{ color?:string }>` 
  color: white;
  display: inline;
  stroke: ${({ color = '#CFD6DB' }) => color};
  fill: ${({ color = '#CFD6DB' }) => color};
  margin: -2px 0 0 8px;
  fill-rule: evenodd; 
  clip-rule: evenodd;
  stroke-linejoin: round; 
  stroke-miterlimit: 1.41421; 
  fill: currentcolor;"
`;

function ArrowDown({ color }:{ color?:string }) {
  return (
    <Icon width="10" color={color} height="6" viewBox="0 0 10 6" fill="none">

      <path d="M9.60344 0.64625C9.40844 0.45125 9.09144 0.45125 8.89644 0.64625L5.25044 4.29225L1.60444 0.64625C1.40944 0.45125 1.09244 0.45125 0.89744 0.64625C0.70244 0.84125 0.70244 1.15825 0.89744 1.35325L4.89744 5.35325C4.99544 5.45125 5.12344 5.49925 5.25144 5.49925C5.37944 5.49925 5.50744 5.45025 5.60544 5.35325L9.60544 1.35325C9.79844 1.15825 9.79844 0.84225 9.60344 0.64625Z" fill="#CFD6DB" />

    </Icon>
  );
}

export default ArrowDown;
